import { motion } from "framer-motion";
// const services = [
//     { title: "Laptops", image: "/assets/laptop.png" },
//     { title: "Desktops", image: "/assets/desktop.png" },
//     { title: "MacBook & Mac Devices", image: "/assets/macbook.png" },
//     { title: "PC Components", image: "/assets/pc_components.png" },
//     { title: "Laptop Batteries & Chargers", image: "/assets/computeramc.png" },
//     { title: "SSDs & RAM", image: "/assets/hardware_upgrade.png" },
//     { title: "Cooling Systems", image: "/assets/cooling_system.png" },
//     { title: "Power Supply Units", image: "/assets/power_supply.png" },
//     { title: "Custom-Built PCs", image: "/assets/custom_pc_build.png" },
// ];
const products = [
    {
        title: "Laptop",
        image: "/assets/laptop.png",
        description: "screens, batteries, keyboards",
    },
    {
        title: "Desktop",
        image: "/assets/desktop.png",
        description: "motherboards, power supplies, desktop components",
    },
    {
        title: "MacBook & Mac Devices",
        image: "/assets/macbook.png",
        description: "batteries, screens",
    },
    {
        title: "PC Components",
        image: "/assets/pc_components.png",
        description: "ram, graphics cards, power supplies, PC components",
    },
    {
        title: "Laptop Batteries & Chargers",
        image: "/assets/computeramc.png",
        description: "batteries, chargers",
    },
    {
        title: "SSDs & RAM",
        image: "/assets/hardware_upgrade.png",
        description: "SSDs, RAM",
    },
    {
        title: "Cooling System Parts",
        image: "/assets/cooling_system.png",
        description: "fans, thermal paste, cooling solutions",
    },
    {
        title: "Power Supply Units",
        image: "/assets/power_supply.png",
        description: "power supply units",
    },
    {
        title: "Custom-Built PCs",
        image: "/assets/custom_pc_build.png",
        description: "customized PCs",
    },
];

const BookServices = () => {
    return (
        <section id="services" className="bg-gray-950 text-yellow-400 py-16 px-4">
            <div className="max-w-7xl mx-auto text-center mb-10">
                <h2 className="text-4xl font-bold mb-4">
                    We Bring Top Services to You
                </h2>
                <p className="text-lg text-gray-300">
                    {/* Best Doorstep Pickup & Drop Facility With Quality Services */}
                    Trusted At-Home Service with a Focus on Quality


                </p>

            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-2">
                {products.map((product, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.3, delay: index * 0.3 }}
                        whileHover={{ scale: [0.98, 1.04, 1] }}
                        transition={{ duration: 0.4 }}
                    >
                        <div className="rounded-2xl text-white bg-gray-800 border border-white/10 p-4 shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-yellow-500/20 hover:border-yellow-400">
                            <img
                                src={product.image}
                                alt={product.title}
                                loading="lazy"
                                className="w-16 h-16 mx-auto object-contain mb-4"
                            />
                            <h3 className="text-lg text-yellow-400 lg:text-2xl font-bold mb-2 text-center">
                                {product.title}
                            </h3>
                            <p className="text-sm lg:text-xl text-center">{product.description}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default BookServices;
